import { z } from "zod";

export const defaultValues = {
	id_horario: 0,
	id_empresa: 0,
	dia_semana: 1,
	hora_abertura: "08:00",
	hora_fechamento: "18:00",
	tipo: "AMBOS",
	ativo: true,
};

export const schema = z.object({
	id_horario: z.union([z.string(), z.number()]).transform((val) => Number(val)),
	id_empresa: z.union([z.string(), z.number()]).transform((val) => Number(val)),
	dia_semana: z.union([z.string(), z.number()]).transform((val) => Number(val)),
	hora_abertura: z.string().min(1, "Obrigatório"),
	hora_fechamento: z.string().min(1, "Obrigatório"),
	tipo: z.enum(["LOJA", "DELIVERY", "AMBOS"], {
		errorMap: () => ({ message: "Selecione um tipo: Loja, Delivery ou Ambos" }),
	}),
	ativo: z.boolean(),
});

